import { ReactElement } from "react";
import { useFamaFlags } from "../api/FamaFlags";

type ThreeSixtyListViewByFlagProps = {
  v2025: ReactElement;
  v2026: ReactElement;
};

/**
 * Picks the list implementation for canonical `/360/...` routes (no `/v2025` or `/v2026` suffix).
 * Controlled by `useFamaFlags().v3Ui360ListViewsV2026`.
 * Dashboard key: `V3-UI-360-LIST-VIEWS-V2026`. Default off -> v2025 implementation.
 */
export function ThreeSixtyListViewByFlag({
  v2025,
  v2026,
}: ThreeSixtyListViewByFlagProps) {
  const { v3Ui360ListViewsV2026 } = useFamaFlags();
  return v3Ui360ListViewsV2026 === true ? v2026 : v2025;
}
